import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import { ROUTE_PATH } from "../../helper/Constants";
import "./Checkout.css";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { displayNo } from "../../helper/Number";
import { useDispatch, useSelector } from "react-redux";
import { sagaActions } from "../../redux/sagas/sagaActions";
import { useEffect, useState } from "react";
import { cartReset } from "../../redux/slices/cartSlice";
import CloseIcon from "@mui/icons-material/Close";
import { getLocalStorage } from "../../helper/Storage";

const Checkout = () => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);

  const lan = getLocalStorage("userLanguage");
  const userAddress = useSelector((state) => state.address.address);
  const myOrder = useSelector((state) => state.cart.cart);

  const incenses = useSelector((state) => state.incenses.items);
  const spices = useSelector((state) => state.spices.items);

  const error = useSelector((state) => state.orderPlaced.error);
  const message = useSelector((state) => state.orderPlaced.message);
  const orderNo = useSelector((state) => state.orderPlaced.orderNo);

  const handleSubmit = () => {
    const order = {
      ...myOrder,
      language: lan,
      fullName: userAddress.fullName,
      phone: userAddress.phone,
      address: userAddress.address,
    };
    dispatch({ type: sagaActions.ORDERS_POST_REQUEST, data: order });
  };

  const handleClose = () => {
    setOpen(false);
    if (!error) {
      dispatch({ type: sagaActions.ORDERS_RESET });
      navigate("/" + ROUTE_PATH.MY_ORDER);
    } else {
      dispatch({ type: sagaActions.ORDERS_RESET });
    }
  };

  useEffect(() => {
    if (error) {
      setOpen(true);
    } else if (message) {
      dispatch(cartReset());
      setOpen(true);
    }
  }, [message, error, dispatch, navigate]);

  return (
    <>
      <Box sx={{ padding: "15px", textAlign: "left" }}>
        {myOrder?.items?.length > 0 &&
        incenses?.length > 0 &&
        spices?.length > 0 ? (
          <Box>
            <Grid container sx={{ alignItems: "center" }}>
              <Typography
                variant="h5"
                sx={{ padding: "10px 20px 10px 0", fontWeight: "bold" }}
              >
                {t("cart.total")}: ₹{" "}
                {displayNo(
                  (
                    myOrder.items.reduce(
                      (a, v) => (a = a + v.offerPrice * v.count),
                      0,
                    ) + myOrder.deliveryFee
                  ).toFixed(2),
                )}
              </Typography>
              <Typography variant="span" sx={{ padding: "10px 20px 10px 0" }}>
                {t("cart.delivery-fee")}: ₹{" "}
                {displayNo(myOrder.deliveryFee.toFixed(2))}
              </Typography>
              <Typography variant="span" sx={{ padding: "10px 20px 10px 0" }}>
                {t("cart.item-total")}: ₹{" "}
                {displayNo(
                  myOrder.items
                    .reduce((a, v) => (a = a + v.offerPrice * v.count), 0)
                    .toFixed(2),
                )}
              </Typography>
            </Grid>
            <Box sx={{ padding: "10px" }}>
              <Grid container>
                <Grid size={{ md: 4, xs: 12 }} sx={{ padding: "5px" }}>
                  <Box
                    sx={{ padding: "10px 20px", border: "1px solid #80787869" }}
                  >
                    <Box>
                      <b>{t("b2b.fullname")} :</b>
                      {userAddress.fullName}
                    </Box>
                    <Box>
                      <b>{t("b2b.phone")} :</b>
                      {userAddress.phone}
                    </Box>
                    <Box>
                      <b>{t("b2b.address")} :</b>
                      {userAddress.address}
                    </Box>
                    <Button variant="contained" onClick={handleSubmit}>
                      {t("cart.checkout")}
                    </Button>
                  </Box>
                </Grid>
                <Grid size={{ md: 8, xs: 12 }} sx={{ padding: "5px" }}>
                  <Box
                    sx={{ padding: "10px 20px", border: "1px solid #80787869" }}
                  >
                    {[...myOrder?.items]
                      ?.sort((a, b) => a.order - b.order)
                      .map((item, index) => {
                        let product =
                          item.type === ROUTE_PATH.INCENSES
                            ? incenses.filter(
                                (incense) => incense.id === item.id,
                              )[0]
                            : spices.filter((spice) => spice.id === item.id)[0];

                        return (
                          <Grid container key={"cart_item_" + index}>
                            <Grid
                              size={{ md: 12, xs: 12 }}
                              container
                              sx={{
                                padding: "2px",
                                borderBottom: 1,
                                borderColor: "#9494943d",
                                marginBottom: "10px",
                              }}
                            >
                              <Grid
                                size={{ md: 2, xs: 4 }}
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignSelf: "center",
                                }}
                              >
                                <Link
                                  to={
                                    "/" +
                                    ROUTE_PATH.PRODUCT_DETAILS +
                                    product.id +
                                    "/" +
                                    item.type
                                  }
                                  style={{ textAlign: "center" }}
                                >
                                  <img
                                    src={
                                      process.env.REACT_APP_API_URL +
                                      product.thumbnail
                                    }
                                    alt={product.thumbnail}
                                    className="checkout-img"
                                  ></img>
                                </Link>
                              </Grid>
                              <Grid size={{ md: 10, xs: 8 }} container>
                                <Grid
                                  size={{ lg: 6 }}
                                  sx={{ padding: "5px", alignSelf: "center" }}
                                >
                                  {
                                    product.name.find((n) => n.key === lan)
                                      .value
                                  }
                                </Grid>
                                <Grid
                                  size={{ lg: 4 }}
                                  sx={{ padding: "5px", alignSelf: "center" }}
                                >
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      fontWeight: "bold",
                                      padding: "0 3px",
                                      fontSize: "15px",
                                    }}
                                  >
                                    ₹
                                    {displayNo(
                                      Number(
                                        product.price.offerPrice * item.count,
                                      ).toFixed(2),
                                    )}
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      textDecoration: "line-through",
                                      color: "#888888ff",
                                    }}
                                  >
                                    ₹
                                    {displayNo(
                                      Number(
                                        product.price.actualPrice * item.count,
                                      ).toFixed(2),
                                    )}
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      fontWeight: "bold",
                                      padding: "0 3px",
                                      color: "#28d311ff",
                                    }}
                                  >
                                    {displayNo(product.price.offer)}
                                    {t("off")}
                                  </Typography>
                                </Grid>
                                <Grid
                                  size={{ lg: 2 }}
                                  sx={{
                                    padding: "5px",
                                    alignSelf: "center",
                                    display: "flex",
                                    justifySelf: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      textAlign: "center",
                                      minWidth: "35px",
                                    }}
                                  >
                                    {displayNo(item.count.toString())}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        );
                      })}
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        ) : (
          <Box sx={{ minHeight: "200px", display: "flex" }}>
            <Box sx={{ margin: "auto" }}>{t("cart.no-item-found")}</Box>
          </Box>
        )}
      </Box>
      <Dialog onClose={handleClose} open={open} maxWidth="xs" fullWidth>
        <DialogTitle
          sx={{ background: message ? "green" : "red", color: "white" }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h6" component="span">
              {message
                ? t("order-place.head.success")
                : error
                  ? t("order-place.head.failed")
                  : ""}
            </Typography>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                color: "white",
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers sx={{ padding: 1 }}>
          <Box sx={{ padding: "10px" }}>
            {message
              ? t("order-place.body.success", { orderNo: displayNo(orderNo) })
              : error
                ? t("order-place.body.failed")
                : ""}
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Checkout;
